"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = require("../../../Layout/Flex");

var _Constant = require("../../../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  flex-direction: column;\n\n  *:last-child {\n    border-right: 0;\n  }\n\n  @media (min-width: ", "px) {\n    flex-direction: row;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ActionLinkContainerRow = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject(), _Constant.Width.SM);

var ActionLinkRow = function ActionLinkRow(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return /*#__PURE__*/_react.default.createElement(ActionLinkContainerRow, (0, _extends2.default)({}, rest, {
    "data-testid": "action-link-row"
  }), children);
};

ActionLinkRow.propTypes = {
  /** These should be of the ActionLink type */
  children: _propTypes.default.node.isRequired
};
var _default = ActionLinkRow;
exports.default = _default;